export const MEDICINE_LIST_REQUEST = "MEDICINE_LIST_REQUEST";
export const MEDICINE_LIST_SUCCESS = "MEDICINE_LIST_SUCCESS";
export const MEDICINE_LIST_FAIL = "MEDICINE_LIST_FAIL";
